
import InsightBarGraphView from './components/InsightBarGraphView'
import InsightColumnStackedGraphView from './components/InsightColumnStackedGraphView'
import InsightLineGraphView from './components/InsightLineGraphView'
import InsightPieGraphView from './components/InsightPieGraphView'
import InsightGeoGraphView from './components/InsightGeoGraphView'
import InsightStatView from './components/InsightStatView'
import InsightKPIFlowView from './components/InsightKPIFlowView'
import InsightViewStatMultiCol from './components/InsightViewStatMultiCol'
import InsightCalendarGraphView from './components/InsightCalendarGraphView'
import InsightProductionNoWorkTableView from './components/InsightProductionNoWorkTableView'
import InsightTableView from './components/InsightTableView'
import InsightSankeyGraphView from './components/InsightSankeyGraphView'
import InsightPyramidView from './components/InsightPyramidView'
import InsightCrossTabView from './components/InsightCrossTabView'

//Make sure this only contains insights related component
const colViewMap = {
    "vInsightViewBarGraph" : InsightBarGraphView,
    "vInsightViewColumnStackedGraph" : InsightColumnStackedGraphView,
    "vInsightViewLineGraph" : InsightLineGraphView,
    "vInsightViewPieGraph" : InsightPieGraphView,
    "vInsightViewGeoGraph" : InsightGeoGraphView,
    "vInsightViewStat" : InsightStatView,
    "vInsightViewKPIFlow" : InsightKPIFlowView,
    "vInsightViewStatMultiCol" : InsightViewStatMultiCol,
    "vInsightViewCalendar" : InsightCalendarGraphView,
    "vInsightProductionNoWorkViewTable" : InsightProductionNoWorkTableView,
    "vInsightTableView" : InsightTableView,
    "vInsightSankeyGraphView" : InsightSankeyGraphView,
    "vInsightPyramidView" : InsightPyramidView,
    "vInsightCrossTabView" : InsightCrossTabView
}

export default colViewMap;
